
import { ApiRequest, postItem, deleteItem, patchItem } from "utils/ApiUtils"
import { updateDeliveryLog } from "utils/SamplesUtil";
import { SampleForm } from 'classes';

const samples_forms_endpoint = "/BaseSamples/Forms"
const labresults_endpoint = "/BaseSamples"
const domain_input_pass_fail = "/Domain?domainName=LuPassFail&includeReserved=false"


function convert_sampleforms_to_table_schema({ data: items }) {
    const columns = items.map(r => {
        const sample = new SampleForm(r);
        return sample;
    });
    return {
        columns
    }
}

async function getSampleForms(baseSampleID) {
    const params = "?id=" + baseSampleID
    const data = await ApiRequest(samples_forms_endpoint, params);
    return convert_sampleforms_to_table_schema(data)
}

async function addTestForm(projectId, data) {
    return null
}

async function updateTestForm(selectedProject, values, data) {
    // console.log(selectedProject, values, data)
    const resourcePath = `${labresults_endpoint}/LabResults/Update`
    data.ParsedForm = JSON.stringify({ jsonSchema: data.jsonSchema, values: values })
    if("RESULTS_STATEMENT" in values) {
        data.PassFailId = values.RESULTS_STATEMENT
    } else if("FIELD_RESULTS" in values) {
        data.PassFailId = values.FIELD_RESULTS
    } else {
        // do nothing
    }
    data.LabSampleFormId = data.formId
    const params = `?labresultid=${data.LabResultId}`;
    const result = await patchItem(resourcePath, params, data)
    return result
}

async function deleteFile(labReusltId, data) {
    // console.log(data)
    const resourcePath = `${labresults_endpoint}/LabResults/Update`;
    data.FileUploadUid = "";
    data.LabSampleFormId = data.formId;
    data.ParsedForm = JSON.stringify({ jsonSchema: data.jsonSchema, values: data.jsonValues });
    const params = `?labresultid=${labReusltId}`
    const result = await patchItem(resourcePath, params, data)
    return result
}

async function updateLabResults(formList, BaseSampleId, systemUserId, sampleByCD) {
    //Get the pass/fail domainID
    const resourcePath = `${domain_input_pass_fail}`
    const passfail = await ApiRequest(resourcePath)
    const NADomainID = passfail.data.filter(d => d.description === 'N/A')[0].domainId
    //Check if form Exist already in the DB
    const data = {}
    // Loop form List and insert form
    const posts = formList.map(form => {
        data.BaseSampleId = BaseSampleId
        data.LabSampleFormId = form.formId
        data.PassFailId = NADomainID
        data.ParsedForm = JSON.stringify({ jsonSchema: form.jsonSchema, values: { "FIELD_RESULTS": NADomainID } })
        data.TestedBy = systemUserId
        return postItem(`${labresults_endpoint}/LabResults/Add`, "", data);
    })
    // Move from pending to active

    const updatedData = sampleByCD.SampleDeliveryLogs.map(record => {
        record.PassFail = false
        return record
    })
    await updateDeliveryLog(updatedData[0]);
    const res = await Promise.all(posts);
    return res;
}


async function deleteLabResultForm(projectId, labform) {
    const resourcePath = `${labresults_endpoint}/LabResults/Delete`
    const params = `?id=${labform.LabResultId}`
    const result = await deleteItem(resourcePath, params)
    return result
}

async function uploadLabResultAttachment(value, { LabResultId }) {
    const resourcePath = `${labresults_endpoint}/LabResults/FileUpload`
    const params = `?id=${LabResultId}`
    const result = await postItem(resourcePath, params, value, true, false)
    return result
}

async function getFile(filename) {
    const resourcePath = `${labresults_endpoint}/download`
    const params = `?fileName=${filename}`
    const result = await ApiRequest(resourcePath, params);
    return result.url;
}

export { getSampleForms, addTestForm, updateTestForm, updateLabResults, deleteLabResultForm, uploadLabResultAttachment,getFile,deleteFile };